/*
 * @Descripttion:
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
/*
 * @Descripttion: 画布功能的常量定义
 * @Author: yang chenglin
 */
export default {
    nodeType:  [
        // 每次请求当前任务数详情，根据这个数组定义的节点类型去匹配每类节点的数量
        {
          name: '选择人群',
          key: 'CROWD_DIG',
          value: 0,
        },
        {
          name: '抽取',
          key: 'CROWD_EXTRACT',
          value: 0,
        },
        {
          name: '合并',
          key: 'CROWD_UNION',
          value: 0,
        },
        {
          name: '交集',
          key: 'CROWD_INTERSECTION',
          value: 0,
        },
        {
          name: '排除',
          key: 'CROWD_DIFFERENCE',
          value: 0,
        },
        {
          name: '拆分',
          key: 'CROWD_SPLIT',
          value: 0,
        },
        {
          name: '去重',
          key: 'CROWD_DIFFERENCES',
          value: 0,
        },
        {
          name: '短信批量发送',
          key: 'BATCH_SMS',
          value: 0,
        },
        {
          name: '发短信',
          key: 'MARKETING_SMS',
          value: 0,
        },
        {
          name: '发富信(旧)',
          key: 'MARKETING_RICH_SMS',
          value: 0,
        },
        {
          name: '发富信',
          key: 'MARKETING_RICH_TEXT_SMS',
          value: 0,
        },
        {
          name: '人群包分析(新)',
          key: 'MARKETING_CROWD_BEHAVIOR_ANALYSIS',
          value: 0,
        },
        {
          name: '人群包分析',
          key: 'MARKETING_PACKAGE_ANALYSIS',
          value: 0,
        },
        {
          name: '保存人群',
          key: 'CROWD_PRESERVATION',
          value: 0,
        },
        {
          name: '优惠促销',
          key: 'MARKETING_MSG_BOX',
          value: 0,
        },
        {
          name: '优惠券',
          key: 'MARKETING_COUPON',
          value: 0,
        },
        {
          name: 'N并1',
          key: 'CROWD_UNION_2',
          value: 0,
        },
        {
          name: 'N交1',
          key: 'CROWD_INTERSECTION_2',
          value: 0,
        },
        {
          name: '咚咚消息',
          key: 'MARKETING_DONGDONG',
          value: 0,
        },
        {
          name: '批量拆分',
          key: 'CROWD_SPLIT_2',
          value: 0,
        },
    ],
    initCreateActivityForm: {
        campaignName: '', // 活动名
        campaignRemark: '', // 备注
        executionPlan: {
            instancePackType: 1, // 判断是否带有消息盒子，固定传1，无意义
            type: 1, // 循环方式 1-单次 2-循环
            startTime: 0, // 循环执行周期，需为时间戳
            endTime: 0,
            frequencyType: 1, // 循环执行频率： 1-按天 2-按周 3-按月
            frequencyValue: 1, // 执行频率下的周期： 按天，按月就是字面量，按周等于∑2的n次幂
            startHour: 14, // 循环执行起始时间点 小时
            startMinute: 0, // 循环执行起始时间点 分
        },
    },
}
